import React, { useState } from 'react';
import { brand } from '../data/site';
type LogoProps = {
  /** Height utilities for the mark, e.g. "h-8 sm:h-10". */
  className?: string;
  /** Extra classes on the wrapper (spacing, alignment). */
  wrapperClassName?: string;
};

/**
 * The Pulse Padel Hub wordmark. The asset is already built for dark surfaces
 * (white "Pulse" outline, electric-blue panel, magenta pulse line), so it sits
 * directly on the navy with a soft neon drop-shadow instead of a light plate —
 * that keeps every part legible without boxing the mark in.
 */
export function Logo({
  className = 'h-10',
  wrapperClassName = ''
}: LogoProps) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className="font-display text-lg font-black uppercase tracking-[0.18em] text-white sm:text-xl" data-id="element-123" data-mp="hszxhxfdb1qn">
        <span className="text-magenta" data-id="element-124" data-mp="2yhca0ac6t2h6">Pulse</span> Padel Hub
      </span>;
  }
  return <span className={`inline-flex items-center ${wrapperClassName}`} data-id="element-125" data-mp="32l1sci29qntr">
      <img src={brand.logoSrc} alt={brand.logoAlt} onError={() => setFailed(true)} draggable={false} className={`w-auto select-none object-contain [filter:drop-shadow(0_0_10px_rgba(30,155,233,0.35))_drop-shadow(0_0_22px_rgba(236,30,156,0.28))] transition-[filter] duration-300 hover:[filter:drop-shadow(0_0_12px_rgba(30,155,233,0.55))_drop-shadow(0_0_30px_rgba(236,30,156,0.45))] ${className}`} data-id="element-126" data-mp="1eurl1r4qu7g6" />
    </span>;
}